import { createSlice } from "redux-starter-kit";
import menuItems_en from "./data/menuItems_en.json";
import menuItems_ja from "./data/menuItems_ja.json";
import { recurseMenuItems } from "./api/initialiseMenu";

export const _menuSlice = () =>
  createSlice({
    slice: "menu",
    initialState: {
      showMenu: false,
      items: {
        en: recurseMenuItems(menuItems_en),
        ja: recurseMenuItems(menuItems_ja),
      },
    },
    reducers: {
      setShowMenu: (state, action) => {
        state.showMenu = action.payload;
      },
    },
  });

// menu link variable substitution
export const replaceAssetVars = (link) =>
  link
    .replace("$wb", "/latest-research/Webcast")
    .replace("$es", "/latest-research/ESG")
    .replace("$ec", "/latest-research/Economics")
    .replace("$eq", "/latest-research/Equity")
    .replace("$fi", "/latest-research/Fixed Income")
    .replace("$fx", "/latest-research/FX")
    .replace("$quf", "/latest-research/Quants Focus")
    .replace("$qu", "/latest-research/Quants")
    .replace("$raf", "/latest-research/Rates Focus")
    .replace("$ra", "/latest-research/Rates")
    .replace("$msf", "/latest-research/Macro Strategy Focus")
    .replace("$ms", "/latest-research/Macro Strategy")
    .replace("$stf", "/latest-research/SP__Credit Focus")
    .replace("$st", "/latest-research/SP__Credit");

// link substitution for $regions:
export const REGIONS = ["Global", "Japan", "Asia ex-Japan", "Americas", "EMEA"];

// node types are attributed by depth, e.g. for depth == 1 node is given key 'menu'
export const nodeTypeByDepth = {
  1: "menu",
  2: "heading",
  3: "group",
  4: "group",
};

export const menuSlice = _menuSlice();
